/* eslint-disable @typescript-eslint/no-explicit-any */
/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

import { useEffect } from 'react';

import {
	Box,
	Progress,
	Image,
	rem,
	Text,
} from '@mantine/core';
import classes from './SingleFileUploadWithProgress.module.css';

// Icons
import SheetIcon from '@assets/images/sheet-file-icon.svg';
import CancelUploadIcon from '@assets/images/cancel-upload-icon.svg';
import { IconCircleXFilled } from '@tabler/icons-react';

// Utils
import { truncateString } from '@utils/functions';
import { Tooltip } from '@components/atoms/Tooltip';

import { notifications } from '@mantine/notifications';

export interface SingleFileUploadWithProgressProps {
	file: any;
	errors: any;
	onDelete: (file: File) => void;
	onUpload: (file: File, url: string) => void;
	onReload: () => void;
}

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
const SingleFileUploadWithProgress = ({
	file,
	onDelete,
	errors,
}: SingleFileUploadWithProgressProps) => {
	useEffect(() => {
		if (errors[0].code == 'csv-invalid-columns') {
			notifications.show({
				title: 'Error',
				message: errors[0].message,
				color: 'error',
			});
		} else {
			notifications.show({
				title: 'Error',
				message:
					'Sorry, the file you uploaded is not compatible. Please ensure you are uploading the correct file format.',
				color: 'error',
			});
		}
	}, []);

	return (
		<Box className={classes.container}>
			<Box className={classes.wrapper}>
				<Image
					style={{
						width: rem(29),
						height: rem(29),
						color: 'var(--mantine-color-dimmed)',
					}}
					src={SheetIcon}
				/>
				<Tooltip
					isActive={file.path.length > 24}
					label={file.path}
				>
					<Text className={classes.filename}>
						{truncateString(file.path, 24)}
					</Text>
				</Tooltip>
				<Box className={classes.containerProgress}>
					<Progress.Root
						size="md"
						className={classes.dropzoneError}
					>
						<Progress.Section
							color="success"
							value={0}
							style={{
								borderRadius: '1px',
							}}
						/>
					</Progress.Root>

					<IconCircleXFilled
						style={{
							width: rem(30),
							height: rem(30),
							color: 'var(--mantine-color-error-9)',
						}}
						stroke={1.5}
					/>

					<Image
						data-testid="D2EtDXR4_Z5jdHi6B-button"
						onClick={() => {
							onDelete(file);
						}}
						className={classes.cancelUpload}
						src={CancelUploadIcon}
					/>
				</Box>
			</Box>
		</Box>
	);
};

export default SingleFileUploadWithProgress;
